import React from 'react';
import classNames from 'classnames';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import ExampleField from 'components/card/components/CardContents/ExampleField';
import styles from './styles.mod.less';
import { type ItemComponentProps } from 'javascripts/dnd/components/types';
import CardLayoutEditorController from '../controllers/CardLayoutEditorController';

const CardPreviewField: React.FC<ItemComponentProps> = ({
  dragging,
  dragItem,
}) => {
  const controller = useController(CardLayoutEditorController);
  const { item } = dragItem;

  return (
    <div
      className={classNames(styles.removableCardItem, {
        [styles.cardFieldWhileDragging]: dragging,
      })}
    >
      <div title={item.field.title}>
        <ExampleField field={item.field} />
      </div>
      <button
        className={classNames('btn-plain', styles.removeCardItem)}
        onClick={() => controller.actionRemoveCardField({ cardField: item })}
        title='Remove field'
      >
        <i className='fa-solid fa-square-xmark' />
      </button>
    </div>
  );
};

export default view(CardPreviewField);
